import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { SlideWrapper, Header, Content, Footer } from './sidebar-styles';
import { SIDEBAR_POPUP_DEFAULT_CONFIG, SIDEBAR_POPUP_DEFAULT_STYLES } from './constants';
import { useSpring } from '@react-spring/web';
var SidebarPopup = function (_a) {
    var isOpen = _a.isOpen, header = _a.header, content = _a.content, footer = _a.footer, rootElementSelector = _a.rootElementSelector, onClose = _a.onClose, contentRef = _a.contentRef, _b = _a.borderRadius, borderRadius = _b === void 0 ? SIDEBAR_POPUP_DEFAULT_CONFIG.borderRadius : _b, width = _a.width, minWidth = _a.minWidth;
    useEffect(function () {
        Modal.setAppElement(rootElementSelector ? rootElementSelector : '#root');
    }, [rootElementSelector]);
    var slideInStyles = useSpring({
        transform: isOpen ? 'translateX(0%)' : 'translateX(100%)',
        config: { tension: 300, friction: 30 },
    });
    // Lock scroll on body when popup is open
    useEffect(function () {
        document.body.style.overflow = isOpen ? 'hidden' : 'auto';
        return function () {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);
    return (React.createElement(Modal, { isOpen: isOpen, onRequestClose: onClose, style: SIDEBAR_POPUP_DEFAULT_STYLES, closeTimeoutMS: 300, contentLabel: "Sidebar Popup" },
        React.createElement(SlideWrapper, { style: slideInStyles, visible: isOpen, width: width + "%", minWidth: minWidth ? minWidth : undefined },
            header && React.createElement(Header, null, header),
            React.createElement(Content, { ref: contentRef }, content),
            footer && React.createElement(Footer, null, footer))));
};
export default React.memo(SidebarPopup);
